import { createContext, useCallback, useContext, useState } from "react";

// Slim session: only the manual-timer progress marker used by soft sequencing.
// No code, no role, no accounts, the app opens directly for anyone.
const KEY = "ailab.highestStartedOrder";
const Ctx = createContext(null);

export function SessionProvider({ children }) {
  const [highestStartedOrder, setH] = useState(() => {
    try {
      const r = window.localStorage.getItem(KEY);
      return r == null ? -1 : parseInt(r, 10);
    } catch {
      return -1;
    }
  });

  const markAreaStarted = useCallback((order) => {
    setH((prev) => {
      if (typeof order !== "number" || order <= prev) return prev;
      try {
        window.localStorage.setItem(KEY, String(order));
      } catch {
        // ignore
      }
      return order;
    });
  }, []);

  return (
    <Ctx.Provider value={{ highestStartedOrder, markAreaStarted }}>
      {children}
    </Ctx.Provider>
  );
}

export function useSession() {
  return useContext(Ctx);
}
